jQuery(document).ready(function($) {
    reload_datepickers();
});
jQuery.ajaxSetup({
    complete: function () {
        setTimeout(() => {
            reload_datepickers();
        }, 100);
    }
});
function reload_datepickers(callback) {
    var $ = jQuery.noConflict();
    var last_elm;
    $('input[data-datepicker]:not(.datepicker-loaded), input[onclick="init_and_open_datepicker(this)"]:not(.datepicker-loaded)').each(function() {
        var elm = $(this);

        elm.addClass('datepicker-loaded');
        if(elm.attr('readonly') !== undefined) {
            return;
        }
        elm.removeAttr('onclick');
        elm.datepicker({
            'regional': 'nl',
        });

        elm.unbind('focus.z-index').bind('focus.z-index', function() {
            let z_index = 100;
            if($(this).parents('.reveal').length > 0) {
                z_index = Math.max.apply(null,
                    $.map($('.reveal'), function(e) {
                        if ($(e).css('position') !== 'static')
                            return parseInt($(e).css('z-index')) || 100;
                    }));
            }
            $(this).datepicker('widget').css('z-index', z_index);
        });

        //Restrict range
        if(elm.is('[data-datepicker-to]')) {
            //Set the change function for the from
            last_elm.on('change', function() {
                elm.datepicker("option","minDate",getDate($(this)));
                elm.trigger('change.textUpdate');
            }).bind([elm]);

            elm.on('change', function() {
                last_elm.datepicker("option", "maxDate", getDate($(this)));
                last_elm.trigger('change.textUpdate');
            }.bind([last_elm]));
        }

        //Use a link as opener
        var prev = $(this).prev();
        if(prev.is('[data-open-datepicker]')) {
            elm.css({
                'border': 'none',
                'opacity': 0,
                'height': 0,
                'line-height': 0,
                'margin': 0,
                'padding': 0,
                'width': 0,
                'display': 'inline'
            });
            prev.click(function(e) {
                e.preventDefault();
                elm.focus();

            }.bind([elm]));

            elm.bind('change.textUpdate',function() {
                if(!elm.is('[data-no-replace]')) {
                    if (prev.find('[data-replace-here]').length > 0) {
                        prev.find('[data-replace-here]').html(elm.val());
                    } else {
                        prev.html(elm.val());
                    }
                }
            }.bind([prev, elm]));
        }

        //Set the last elm
        last_elm = elm;

        // Whenever an element gets cloned through repeat items, we need to re-initialize the datepicker
        const cloneableElement = elm.parents('[data-belongs-to-uid]');
        cloneableElement.bind('on-clone', function() {
            const reveal = cloneableElement.parents('.reveal');
            reveal.find('input.hasDatepicker')
                .datepicker( "destroy" )
                .removeClass('datepicker-loaded')
                .removeClass('hasDatepicker')
                .attr('data-datepicker', 1)
            ;
            reload_datepickers();
        });
    });

    if(typeof callback == 'function') {
        callback();
    }

    function getDate( element ) {
        var date;
        try {
            date = element.datepicker('getDate');
        } catch( error ) {
            date = null;
        }

        return date;
    }
}
function init_and_open_datepicker(elm) {
    var $ = jQuery.noConflict();
    elm = $(elm);
    elm.attr('data-datepicker', 1);
    if(elm.attr('data-datepicker-to') != undefined || elm.attr('data-datepicker-from') != undefined) {
        var other_name = 'data-datepicker-to';
        if(elm.attr('data-datepicker-to') != undefined) {
            other_name = 'data-datepicker-from';
        }
        var other_element = find_element('['+other_name+']', elm.parent());
        if(other_element != undefined) {
            other_element.attr('data-datepicker', 1);
        }
    }
    reload_datepickers(function() {
        elm.focus();
    }.bind([elm]));

    function find_element(name, in_element) {
        var finding = in_element.find(name);
        if(finding.length == 0 && in_element.parent().length > 0) {
            return find_element(name, in_element.parent());
        } else if(in_element.parent().length == 0) {
            return undefined;
        }
        return finding;
    }
}
